// components/PasswordInput.js
import React, { useState } from "react";
import PropTypes from "prop-types";
import Input from "./Input";
import { validatePassword } from "../../utils/validation";

const PasswordInput = ({
  value,
  onChange,
  isFullWidth = false,
  showConditions = true,
  ...props
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [passwordStrength, setPasswordStrength] = useState({
    minLength: false,
    hasUpperCase: false,
    hasLowerCase: false,
    hasNumber: false,
    hasSpecialChar: false,
    isValid: false,
  });

  const toggleVisibility = () => setIsVisible(!isVisible);

  const handlePasswordChange = (e) => {
    const password = e.target.value;
    const validation = validatePassword(password);
    setPasswordStrength(validation);
    onChange(e);
  };

  return (
    <div className="relative w-full">
      <Input
        type={isVisible ? "text" : "password"}
        startIcon="lock"
        endIcon={isVisible ? "visibility" : "visibility_off"}
        value={value}
        onChange={handlePasswordChange}
        isFullWidth={isFullWidth}
        onEndIconClick={toggleVisibility}
        {...props}
      />
      {showConditions && (
        <div className="mt-2 mb-2">
          <p
            className={`text-sm ${passwordStrength.minLength ? "text-agPrimary font-thin password" : "text-agLightGray font-thin password "}`}
          >
            {passwordStrength.minLength ? "✔" : "✘"} Minimum 6 characters
          </p>
          <p
            className={`text-sm ${passwordStrength.hasUpperCase ? "text-agPrimary font-thin password " : "text-agLightGray font-thin password"}`}
          >
            {passwordStrength.hasUpperCase ? "✔" : "✘"} Uppercase letter
          </p>
          <p
            className={`text-sm ${passwordStrength.hasLowerCase ? "text-agPrimary font-thin password" : "text-agLightGray font-thin password"}`}
          >
            {passwordStrength.hasLowerCase ? "✔" : "✘"} Lowercase letter
          </p>
          <p
            className={`text-sm ${passwordStrength.hasNumber ? "text-agPrimary font-thin password" : "text-agLightGray font-thin password"}`}
          >
            {passwordStrength.hasNumber ? "✔" : "✘"} Number
          </p>
          <p
            className={`text-sm ${passwordStrength.hasSpecialChar ? "text-agPrimary font-thin password" : "text-agLightGray font-thin password"}`}
          >
            {passwordStrength.hasSpecialChar ? "✔" : "✘"} Special character
          </p>
        </div>
      )}
    </div>
  );
};

PasswordInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  isFullWidth: PropTypes.bool,
  showConditions: PropTypes.bool,
};

export default PasswordInput;
